export const validStatusCode = [200, 201, 202, 204, 205, 206, 207, 208, 226];

